import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogData } from './dialog.model';

@Component({
  selector: 'app-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.scss'],
})
export class DialogComponent {
  public text;
  constructor(
    public dialogRef: MatDialogRef<DialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) {}

  public onClickToSelectPrimary(primaryBtnName: string) {
    this.dialogRef.close({ data: primaryBtnName });
  }

  public onClickToSelectSecondary(secondaryBtnName: string) {
    this.dialogRef.close({ data: secondaryBtnName });
  }
}
